import { createStore } from '@xstate/store';

/**
 * Cross-module trigger for opening the bug-report widget. Pages that want to
 * open the widget (e.g. the Support Center contact card) send an open request
 * here; the mounted widget variant (custom dialog or Sentry feedback form)
 * listens via `bugReportStore.on('openRequested', …)` and reacts.
 */
export const bugReportStore = createStore({
  context: {},
  emits: {
    openRequested: () => {},
  },
  on: {
    requestOpen: (context, _event, enqueue) => {
      enqueue.emit.openRequested();

      return context;
    },
  },
});

/**
 * Requests the mounted bug-report widget to open its dialog/form.
 * No-ops visually when no widget is mounted (variant 'none').
 */
export function requestBugReportOpen() {
  bugReportStore.trigger.requestOpen();
}
